import { sendRequest } from "../../shared/cs2n_comms";
var cs2nDefaultProps = {
  domain: "http://localhost:5000",
  requirement: {
    id: 2288
  },
  token: "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxMjQ0NTh9.iR0MutX3ZFCKp4M1NgdIE_DFifjkuiFREx2tUfcN51Y",
  game_settings: {
    scene_name: "default",
    difficulty: "level1"
  },
  completed: false
};

var updateUserMilestone = function updateUserMilestone(game) {
  sendRequest("client_api/v1/web_game_scores", "post", {
    id: game.requirement.id,
    score: 99
  }, game.token, game.domain);
};

var game = function game() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cs2nDefaultProps;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "LOAD_CS2N_DATA":
      return action.data;

    case "COMPLETE_MILESTONE":
      updateUserMilestone(action.game);
      state.completed = true;
      return state;

    default:
      return state;
  }
};

export default game;